import Card from 'components/Layout/Card';
import React, { useState } from 'react';
import Overall from './Overall';
import DetailedView from './DetailedView';
import './NewSubmittedPapers.scss';
import { getDataFromLocalStorage } from 'utils/helpers';
import { handleCallhippoCall, setTabType } from 'store/slices';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'components/Layout/Modal';
import Button from 'components/form/Button';
import { useNavigate, useParams } from 'react-router-dom';
import CallConnectPopup from 'components/Layout/CallConnectPopup/CallConnectPopup';
import TabLayout from 'components/Layout/TabLayout';

const NewSubmittedPapers = () => {
  const userData = getDataFromLocalStorage();
  const showActionButtons = !['1'].includes(userData?.resource_role);
  const dispatch = useDispatch();
  const reduxData = useSelector((state) => state.global);
  const tabType = reduxData?.tabType;
  const [isCallConnect, setIsCallConnect] = useState({});
  const tabs = [
    { key: '0', label: 'Overall' },
    { key: '1', label: 'Detailed View' },
  ];
  return (
    <>
      <Card className="cps-20 cpe-20 cpt-15">
        <TabLayout tabs={tabs}
          activeKey={tabType}
          onChange={(key) => dispatch(setTabType(key))}
        />
        {tabType === '0' && (
          <Overall
            showActionButtons={showActionButtons}
            setIsCallConnect={setIsCallConnect}
          />
        )}
        {tabType === '1' && (
          <DetailedView
            showActionButtons={showActionButtons}
            setIsCallConnect={setIsCallConnect}
          />
        )}
      </Card>

      {isCallConnect && Object.keys(isCallConnect).length > 0 && (
        <CallConnectPopup
          onHide={() => setIsCallConnect({})}
          data={isCallConnect}
        />
      )}
    </>
  );
};

export default NewSubmittedPapers;
